import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { resolveRedirect } from "@/lib/redirects";
import { initClickTracking } from "@/lib/analytics";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { OnlineBand } from "@/components/OnlineBand";
import { MobileBar } from "@/components/MobileBar";
import { Toaster } from "@/components/ui/sonner";
import { BusinessJsonLd } from "@/components/BusinessJsonLd";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import MaintenancePlans from "@/pages/MaintenancePlans";
import Commercial from "@/pages/Commercial";
import ServiceAreas from "@/pages/ServiceAreas";
import CityPage from "@/pages/CityPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faqs from "@/pages/Faqs";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import SetPassword from "@/pages/SetPassword";
import ResetPassword from "@/pages/ResetPassword";
import EstimateLanding from "@/pages/EstimateLanding";
import ThankYou from "@/pages/ThankYou";
import CondoAssociations from "@/pages/CondoAssociations";
import PartnerBuilding from "@/pages/PartnerBuilding";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

export function Layout() {
  const { pathname } = useLocation();
  const redirect = resolveRedirect(pathname);
  if (redirect) return <Navigate to={redirect} replace />;
  const bare = pathname === "/ac-replacement-estimate";
  return (
    <>
      <ScrollToTop />
      <BusinessJsonLd />
      {!bare && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/maintenance-plans" element={<MaintenancePlans />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/condo-associations" element={<CondoAssociations />} />
          <Route path="/partners/:buildingSlug" element={<PartnerBuilding />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/areas/:slug" element={<CityPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/account" element={<Account />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/ac-replacement-estimate" element={<EstimateLanding />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!bare && <OnlineBand />}
      {!bare && <Footer />}
      {!bare && <MobileBar />}
      <Toaster />
    </>
  );
}

function App() {
  useEffect(() => {
    initClickTracking();
  }, []);
  return (
    <div className="App pb-16 lg:pb-0">
      <BrowserRouter>
        <AuthProvider>
          <Layout />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
